import {
  AvatarGroup,
  AvatarWithTooltip,
  BetaDataTableCell as Cell,
} from "@zapier/design-system";
import { useTranslations } from "@zapier/i18n";
import styles from "./AccessCell.module.css";
import { ConnectionGroup, ConnectionMember, Member } from "@zapier/bff";
import { getInitials } from "../../../utils";

interface Props {
  groups: ConnectionGroup[];
  members: ConnectionMember[];
  owner: Member | null | undefined;
  /** Set for managed connections, which have no individual owner; renders the owning workspace/org. */
  workspace?: { name: string; logoUrl?: string | null };
}

export function AccessCell({ groups, members, owner, workspace }: Props) {
  const t = useTranslations("connections-table");
  return (
    <Cell className={styles.root}>
      <AvatarGroup size="small">
        {!!workspace && (
          <AvatarWithTooltip
            key="workspace"
            initials={getInitials(workspace.name)}
            name={t("tooltips.workspace-owner-tooltip", {
              workspace: workspace.name,
            })}
            url={workspace.logoUrl}
          />
        )}
        {!!owner && (
          <AvatarWithTooltip
            key="owner"
            initials={getInitials(owner.fullName)}
            name={`${owner.fullName || ""} is the owner`}
            url={owner.photoUrl}
          />
        )}
        {groups.map((group, index) => (
          <AvatarWithTooltip
            key={index}
            name={group.name || ""}
            url={group.photoUrl}
          />
        ))}
        {members.map((member, index) => (
          <AvatarWithTooltip
            key={index}
            name={member.fullName || ""}
            url={member.photoUrl}
          />
        ))}
      </AvatarGroup>
    </Cell>
  );
}
